import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicSodiumPotassiumCombined from "./index";

const CardiometabolicSodiumPotassiumWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicSodiumPotassiumCombined}
    keyControlsId="cardiometabolic-sodium-potassium-key"
    {...props}
  />
);

export default CardiometabolicSodiumPotassiumWithToggleKey;
